export enum DroneFlightStatusEnum {
    Unknown = 0,
    Cancelled = 1,
    Scheduled = 2,
    Completed = 3
}

